<template>
  <div class="privacy-police">
    <div class="main_wrap">
      <header>
        <p>
          <img src="../../assets/navigation_back.png" @click="returnToPayBefore">
        </p>
        <p>{{ $t('privacyPolicy.head') }}</p>
      </header>
      <section>
        <p class="title">{{ $t('privacyPolicy.head') }}</p>
        <div class="content">
          <p class="content_title">{{$t('privacyPolicy.contentTitle')}}</p>

          <p class="title_one title_detail">{{$t('privacyPolicy.title_one')}}</p>
          <p class="content_one">{{$t('privacyPolicy.content_one')}}</p>

          <p class="title_two title_detail">{{$t('privacyPolicy.title_two')}}</p>
          <p class="content_two">{{$t('privacyPolicy.content_two')}}</p>

          <p class="title_three title_detail">{{$t('privacyPolicy.title_three')}}</p>
          <p class="content_three">{{$t('privacyPolicy.content_three')}}</p>

          <p class="title_four title_detail">{{$t('privacyPolicy.title_four')}}</p>
          <p class="content_four">{{$t('privacyPolicy.content_four')}}</p>

          <p class="title_five title_detail">{{$t('privacyPolicy.title_five')}}</p>
          <p class="content_five">{{$t('privacyPolicy.content_five')}}</p>

          <p class="title_six title_detail">{{$t('privacyPolicy.title_six')}}</p>
          <p class="content_six">{{$t('privacyPolicy.content_six')}}</p>

        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  // data () {
  //   return {
  //   }
  // },
  methods: {
    returnToPayBefore () {
      this.$router.push({ name: 'index', query: { link_id: this.$route.query.link_id } })
    }
  }
}
</script>

<style lang="scss">
@media only screen and (max-width: 900px) {
  .privacy-police {
    background-color: #FFFFFF;
    .main_wrap {
      header {
        height: 44.69px;
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        border-bottom: 1px solid #EBEBEB;
        background-color: #FFFFFF;
        p:nth-child(1) {
          position: absolute;
          left: 16px;
          top: 14px;
          img {
            height: 18px;
            width: 9px;
            vertical-align: middle;
          }
        }
        p:nth-child(2) {
          width: 100%;
          text-align: center;
          height: 24px;
          font-size: 17px;
          line-height: 24px;
          margin-top: 11px;
        }
      }
      section {
        margin-top: 69.69px;
        padding-left: 15px;
        padding-right: 15px;
        .title {
          width: 100%;
          text-align: center;
          height: 20px;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
        .content {
          margin-top: 15px;
          font-size: 15px;
          line-height: 24px;
          color: #606470;
          white-space: pre-line;
          p {
            margin-bottom: 6px;
          }
          .title_detail {
            margin-top: 10px;
            margin-bottom: 4px;
            font-size: 15px;
            font-weight: 500;
            color: #2A2B2C
          }
        }
      }
    }
  }
}
</style>
